import { Component, OnInit, OnDestroy } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { CadastroPix, DadoBancarioCedenteCadastro } from 'src/app/models/dado-bancario-cedente-cadastro';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DadoBancarioCedente, PixResponse } from 'src/app/models/dado-bancario-cedente';
import { Subscription } from 'rxjs';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { CedenteCnpjAlternativo } from 'src/app/models/cedente-cnpj-alternativo';
import { Banco } from 'src/app/models/banco';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';


import { Router, ActivatedRoute } from '@angular/router';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ChavePixService } from 'src/app/services/chave-pix.service';

@Component({
    selector: 'app-dado-bancario-edit',
    templateUrl: './dado-bancario-edit.component.html',
    styleUrls: ['./dado-bancario-edit.component.css']
})
export class DadoBancarioEditComponent implements OnInit {

    private currentUser: Auth;
    public dadoBancarioCadastro: DadoBancarioCedenteCadastro;

    public bancosList: Banco[];
    public dadoBancarioFormGroup: FormGroup;
    canEdit = false;

    private dadoBancario: DadoBancarioCedente;
    private id: string;
    private routeSubscription: Subscription;

    dropdownList = [];
    dropdownSettings: IDropdownSettings = {};
    selectedItems = [];
    formPix: FormGroup;

    public maskCnpjRaiz = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    public maskCnpjComplemento =  [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    /* wwwwwwww-wwww-wwww-wwww-wwwwwwwwwwww */
    public chaveAleMAsk = [/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/ ];
    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public celularMask = ['(',/\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-' ,/\d/, /\d/, /\d/, /\d/];
    public complementoMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    public cedenteCnpjAlternativo: CedenteCnpjAlternativo;
    public cnpjError = false;
    public possuiConta = false;
    public chavePix = "";
    public typesPix: Array<PixResponse>;
    public tipoChavePix: number;
    public tipoChavePixDesc: string;
    public cadastroForm: CadastroPix;

    constructor(
        private formBuilder: FormBuilder,
        private dadoBancarioService: DadoBancarioService,
        private authenticationService: AuthenticationService,
        private pixService: ChavePixService,
        private cedenteService: CedenteService,
        private parametrosDataService: ParametrosDataService,
        private alertService: NewAlertService,
        private router: Router,
        private fb: FormBuilder,
        private route: ActivatedRoute) {
    }

    public get form() {
        return this.dadoBancarioFormGroup.controls;
    }



    ngOnInit() {

        /* this.possuiConta = this.dadoBancarioService.getPossuiConta();
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = params.get('id');
        }); */

        this.currentUser = this.authenticationService.currentUserValue;

        this.load();

    /* this.bancoParams = history.state.banco;
    console.log('teste state', this.bancoParams); */
    this.chavePix = history.state.chave;

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'nome',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.pixService.getTipoChavePix('j').subscribe(res => {
      if (res.status === 1) {

        this.typesPix = res.result;
        this.dropdownList = this.typesPix.map(element =>{
          return{
            id: element.keyType,
            nome: element.description
          }
        })
      }
    });


    this.criarFormularioDadosBancarios();

        /* this.dadoBancarioService.getAllBancos().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.bancosList = response.result;
                    for (const b of this.bancosList) {
                        if (b.preferencial) {
                            b.preferencialSymbol = '*preferencial';
                        }
                    }
                    this.bancosList = this.bancosList.sort((a, b) => a.codigo.localeCompare(b.codigo));
                } else {
                    this.alertService.warning(response.message);
                }
            }, error => {
                console.log(error);
                this.alertService.error('Ocorreu um erro ao tentar buscar os dados!');
            }
        );

        this.cedenteCnpjAlternativo = new CedenteCnpjAlternativo(false, '', ''); */

        // usar para criar / editar
        /* this.createForm(new DadoBancarioCedenteCadastro(null, '', '', '', '', false, false, ''), this.cedenteCnpjAlternativo ); */

        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        /* this.dadoBancarioService.getByGuid(this.id, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.dadoBancario = response.result;
                    if (this.dadoBancario.cnpj != null) {
                        const raiz = ('00000000000000' + this.dadoBancario.cnpj.toString()).slice(-14).substring(0, 8);
                        const complemento = ('00000000000000' + this.dadoBancario.cnpj.toString()).slice(-14).substring(8, 14);

                        this.dadoBancarioFormGroup.controls.outroCnpj.setValue(true);
                        this.dadoBancarioFormGroup.controls.cnpjRaiz.setValue(raiz);
                        this.dadoBancarioFormGroup.controls.cnpjComplemento.setValue(complemento);
                        this.cedenteCnpjAlternativo.raiz = raiz;
                        this.cedenteCnpjAlternativo.complemento = complemento;
                        this.cedenteCnpjAlternativo.novoCnpj = true;
                    } else {
                        this.cedenteService.getInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                            async response => {
                                const cnpj = ('00000000000000' + response.result.cedente.cnpj
                                    .toString())
                                    .slice(-14)
                                    .substring(0, 8);

                                this.dadoBancarioFormGroup.controls.cnpjRaiz.setValue(cnpj);
                                this.cedenteCnpjAlternativo.raiz = cnpj;
                            },
                            error => {
                                console.log('erro ao buscar cnpj');
                            }
                        );
                    }

                    this.createForm(new DadoBancarioCedenteCadastro(this.dadoBancario.bancoId, this.dadoBancario.agencia, this.dadoBancario.digitoAgencia,
                        this.dadoBancario.conta, this.dadoBancario.digitoConta, this.dadoBancario.contaDeposito, this.dadoBancario.preferencial, this.dadoBancario.cnpj),
                        this.cedenteCnpjAlternativo);
                    this.canEdit = true;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao buscar os dados!');
                console.log(error);
                this.router.navigate(['list'], { relativeTo: this.route.parent });
            }
        ); */

    }

    load(){
        this.pixService.getChavePix(this.currentUser.token.pessoaId).subscribe(res =>{
          if (res.status === 1){
            this.chavePix = res.result.pixKey;

          }else{
            console.log(res);

          }

        });
      }

      criarFormularioDadosBancarios() {
        /* if (this.bancoParams[0].bancoPreferencial) {
          this.isCheckedContaP = true;
        }

         this.formPix = this.fb.group({
          agencia: [this.bancoParams[0].agencia, Validators.required],
          conta: [this.bancoParams[0].conta, Validators.required],
          contaDigito: [this.bancoParams[0].digitoConta, Validators.required],
          agDigito: [this.bancoParams[0].digitoAgencia],
          cnpj: [this.cnpj],
          complemento: [],
          contaPrincipal: [],
        });  */

        this.formPix = this.fb.group({
          chave: [this.chavePix, Validators.required],
          tipoChave: [this.tipoChavePix, Validators.required]

        });
      }

    /* ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    } */
    enviarDados() {

        this.cadastroForm = {
          pessoaId: this.currentUser.token.pessoaId,
          chave: this.formPix.get('chave').value,
          tipoChave: this.tipoChavePix
        };
        if(this.tipoChavePix == 1 ||this.tipoChavePix == 2 || this.tipoChavePix == 3 )
            this.cadastroForm.chave = this.cadastroForm.chave.replace(/[^\d]+/g,'');

        this.pixService.updateChavePix(this.cadastroForm.pessoaId, this.cadastroForm.chave, this.cadastroForm.tipoChave).subscribe(res =>{
          if(res.status == 1){
            this.alertService.success('Chave pix alterada com sucesso');
            this.router.navigate(['/portal/dadobancario/list']);

          }else{
            this.alertService.error(res.message);
          }

        });
      }

      onItemSelect(item: any) {
        this.tipoChavePix = item.id;
        this.tipoChavePixDesc = item.description;
      }



    createForm(dadoBancarioCadastro: DadoBancarioCedenteCadastro, cedenteCnpjAlternativo: CedenteCnpjAlternativo) {
       const preferencial = this.possuiConta || dadoBancarioCadastro.bancoPreferencial;

       this.dadoBancarioFormGroup = this.formBuilder.group({
            bancoId: new FormControl(dadoBancarioCadastro.bancoId, [
                Validators.required
            ]),
            bancoPreferencial: new FormControl({value: preferencial, disabled: preferencial}),
            agencia: new FormControl(dadoBancarioCadastro.agencia, [
                Validators.required,
                Validators.maxLength(10)
            ]),
            digitoAgencia: new FormControl(dadoBancarioCadastro.digitoAgencia, [
                Validators.maxLength(2)
            ]),
            conta: new FormControl(dadoBancarioCadastro.conta, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            digitoConta: new FormControl(dadoBancarioCadastro.digitoConta, [
                Validators.required,
                Validators.maxLength(2)
            ]),
            outroCnpj: new FormControl(cedenteCnpjAlternativo.novoCnpj),
            cnpjRaiz: new FormControl(cedenteCnpjAlternativo.raiz),
            cnpjComplemento: new FormControl(cedenteCnpjAlternativo.complemento)
        });
    }

    validarCNPJ(cnpj: any) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj == '') { return false; }

        if (cnpj.length != 14) {
            return false;
        }

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        const digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) {
                pos = 9;
          }
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) {
                pos = 9;
          }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
              return false;
        }

        return true;
    }

    updateParametros() {
        this.cedenteService
            .getParametros(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId
            )
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    // carregar parametros
                    this.parametrosDataService.setCurrentParametrosValue(
                        response.result
                    );
                }
            });
    }

    /* onSubmit(dadoBancarioCadastro: DadoBancarioCedenteCadastro) {
        if (this.dadoBancarioFormGroup.controls.outroCnpj.value) {
            const cnpj = `${this.dadoBancarioFormGroup.controls.cnpjRaiz.value}/${this.dadoBancarioFormGroup.controls.cnpjComplemento.value}`;
            if (!this.validarCNPJ(cnpj)) {
                this.cnpjError = true;
            } else {
                this.cnpjError = false;
                dadoBancarioCadastro.cnpj = cnpj.replace(/[^\d]+/g, '');
            }
        } else {
            this.cnpjError = false;
        }

        if (this.dadoBancarioFormGroup.valid && !this.cnpjError) {
            this.dadoBancarioService.update(this.dadoBancario.dadoBancarioGuid, dadoBancarioCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message, true);
                        this.updateParametros();
                        this.router.navigate(['list'], { relativeTo: this.route.parent });
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao buscar os dados!');
                    console.log(error);
                }
            );
        } else {
            GenericValidator.verifierValidatorsForm(this.dadoBancarioFormGroup);
        }
    } */

}
